import React from 'react';
import { MenuIcon } from 'lucide-react';
export const DashboardHeader = () => {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-152">
      <div className="flex items-center justify-between px-4 py-3" data-id="element-153">
        <button className="md:hidden p-2 rounded-md text-gray-500 hover:text-gray-600 hover:bg-gray-100 focus:outline-none" data-id="element-154">
          <MenuIcon size={24} data-id="element-155" />
        </button>
        <div className="flex-1" data-id="element-156"></div>
        <div className="flex items-center" data-id="element-157">
          <div className="relative" data-id="element-158">
            <div className="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium cursor-pointer" data-id="element-159">
              A
            </div>
          </div>
        </div>
      </div>
    </header>;
};